module.exports = "/images/Sub-What we do-01.jpg";